import BottomSheet, { BottomSheetProps } from '@gorhom/bottom-sheet';
import React, { useCallback, useRef } from 'react';
import { BackHandler, NativeEventSubscription } from 'react-native';

// Taken from github issue:
// https://github.com/gorhom/react-native-bottom-sheet/issues/556#issuecomment-1023123434
export const useBottomSheetBackHandler = (
  bottomSheetRef: React.RefObject<BottomSheet | null>,
) => {
  const backHandlerSubscriptionRef = useRef<NativeEventSubscription>(null);
  const handleSheetPositionChange = useCallback<
    NonNullable<BottomSheetProps['onChange']>
  >(
    (index) => {
      const isBottomSheetVisible = index >= 0;
      if (isBottomSheetVisible && !backHandlerSubscriptionRef.current) {
        backHandlerSubscriptionRef.current = BackHandler.addEventListener(
          'hardwareBackPress',
          () => {
            bottomSheetRef.current?.close();
            return true;
          },
        );
      } else if (!isBottomSheetVisible) {
        backHandlerSubscriptionRef.current?.remove();
        backHandlerSubscriptionRef.current = null;
      }
    },
    [bottomSheetRef, backHandlerSubscriptionRef],
  );
  return { handleSheetPositionChange };
};
